import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Wifi = function Wifi(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 19.5h.01M22.8064 8.7008C19.9595 6.092 16.1656 4.5 11.9999 4.5S4.0402 6.092 1.1934 8.7008m3.5385 3.5422C6.6701 10.5357 9.2141 9.5 12 9.5s5.3299 1.0357 7.268 2.743m-3.5697 3.5321A5.974 5.974 0 0 0 11.9999 14.5a5.975 5.975 0 0 0-3.7445 1.3116"
    })
  }));
};
export default Wifi;